













import {Component, Prop, Vue} from 'vue-property-decorator';
import JdsButton from "@/design-system/components/Button/JdsButton.vue"
import {ActiveInject, ActiveProvide} from "@/support/reactive"
import JdsToolbar from "@/design-system/patterns/JdsToolbar.vue"

/**
 * @status stable
 * @published 4.0.0
 * @changelog 4.0.0 Published.
 */
@Component({
    components: {JdsToolbar, JdsButton}
})
export default class JdsPageIntro extends Vue {
    @ActiveProvide('jds.button.size') buttonSize = 'high'
    @ActiveProvide('jds.button.type') buttonType = 'primary'

    @ActiveInject({from: 'jds.page-layout.stack', default: false}) stacking!: boolean

}
